import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux'
import autobind from 'autobind-decorator'
import * as StatusTypes from '../../../constants/contents/EntryStatusTypes';
import {closeChangeStatusButton, receiveItems, toggleChangeStatusButton, updateItem} from '../../../actions/contents/post';
import WindowEventHelper from "../../../lib/WindowEventHelper";
import {jsonResponseHandler} from "../../../utils/FetchHelper";
import {isDescendant} from "../../../utils/DomHelper";
import EntryStatusChangeButton from "../EntryStatusChangeButton";
import * as CategoryVisibility from "../../../constants/category/CategoryVisibility";
import {addPrefix} from "../../../utils/UriUtil";
import {TISTORY} from "../../../constants/Service"

function getEditUrl(post) {
  return addPrefix(`/manage/post/${post.id}?returnURL=${encodeURIComponent(location.href)}`);
}

@connect(state => ({
    changeStatusActivationId: state.post.moreButton.changeStatusActivationId,
    activatedId: state.post.moreButton.activatedId
}), dispatch => ({
    toggleChangeStatusButton: (itemId) => {
        dispatch(toggleChangeStatusButton(itemId))
    },
    closeChangeStatusButton: () => {
        dispatch(closeChangeStatusButton())
    },
    handleReceivePosts: (items, totalCount) => {
        dispatch(receiveItems(items, totalCount))
    },
    handleUpdateItem: (item) => {
        dispatch(updateItem(item))
    },
    dispatch
}))
class PostListItemButton extends Component {

  constructor(props) {
    super(props);
    this.state = {
      statusOpen: false
    }
  }


  componentDidMount() {
        WindowEventHelper.add("click", this.handleWindowClick)
    }

    componentWillUnmount() {
        WindowEventHelper.remove("click", this.handleWindowClick)
    }

    @autobind
    handleWindowClick(e) {
        const {changeStatusActivationId, toggleChangeStatusButton, item} = this.props;
        const {root} = this.refs;
        let target = e.target;

        if ((changeStatusActivationId === item.id) && (!isDescendant(root, target))) {
            toggleChangeStatusButton(item.id);
        }
    }

    @autobind
    handleChangeStatus(nextStatus) {
        const {item, handleHidden, handleVisible, handleProtect, handleFollowed,toggleChangeStatusButton} = this.props;

        if (item.visibility === nextStatus) {
            toggleChangeStatusButton(item.id);
            return null;
        }

        switch (nextStatus) {
            case StatusTypes.PUBLIC :
                handleVisible(item);
                break;
            case StatusTypes.PRIVATE :
                handleHidden(item);
                break;
            case StatusTypes.PROTECTED :
                handleProtect(item);
                break;
            case StatusTypes.FOLLOWED :
                handleFollowed(item);
                break;
        }

        toggleChangeStatusButton(item.id);

    }

    @autobind
    handleDelete() {

        const {item, handleUpdateItem, dispatch} = this.props;

        if (!item.editable) {
            alert('편집자 이상의 권한이 필요합니다.');
        } else if (confirm('선택한 글을 삭제하시겠습니까?')) {
            item.deleting = true;
            handleUpdateItem(item);

            fetch(addPrefix("/manage/post/") + item.id + ".json", {
                method: "delete",
                credentials: "include",
                headers: {'Content-Type': 'application/x-www-form-urlencoded'}
            })
                .then(jsonResponseHandler(dispatch))
                .then(data => {
                    this.reFetchPosts();
                })
                .catch(e => {
                    item.deleting = false;
                    handleUpdateItem(item);
                    console.log(e)
                })
        }
    }

    reFetchPosts() {

        const {dispatch} = this.props;

        fetch(addPrefix("/manage/posts.json") + location.search, {
            method: 'GET',
            credentials: 'include'
        })
            .then(jsonResponseHandler(dispatch))
            .then(r => r.json())
            .then(data => {
                this.props.handleReceivePosts(data.items, data.totalCount)
            })
            .catch(e => {
                console.log(e)
            })
    }

    @autobind
    handleClickStatus() {
      this.setState({
        statusOpen: true
      })
    }

    render() {
        const { item } = this.props;
        const isReservedItem = item.isScheduled;
        const isPrivateCategory = CategoryVisibility.isPrivate(item.categoryVisibility);
        const disabledAction = isReservedItem || item.deleting || !item.editable || isPrivateCategory;

        const types = window.Config.service === TISTORY?
          [ StatusTypes.PUBLIC, StatusTypes.PROTECTED, StatusTypes.PRIVATE ] :
          [ StatusTypes.PUBLIC, StatusTypes.FOLLOWED, StatusTypes.PRIVATE ]

        return (
          <div ref="root">
            {(item.editable === true) &&
              <Fragment>
                <a className='btn_post' href={getEditUrl(item)}>수정</a>
                <a className='btn_post' href='#' onClick={this.handleDelete}>삭제</a>
              </Fragment>
            }
            <a className='btn_post' href={addPrefix(`/manage/statistics/entry/${item.id}`)} target="_blank">통계</a>

            <EntryStatusChangeButton
              className='opt_post1'
              item={item}
              disabled={disabledAction}
              types={types}
              onChange={this.handleChangeStatus}
            />
          </div>
        )

    }
}

PostListItemButton.propTypes = {};

export default PostListItemButton;
